/* eslint-disable */
import { lazy } from 'react';
// import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';

const dashboard = lazy(() => import('views/dashboard/Dashboard'));
const storefrontLandingPage = lazy(() => import('views/storefront-landing-page/StorefrontLandingPage'));
const products = {
  list: lazy(() => import('views/products/list/ProductsList')),
  inventory_status: lazy(() => import('views/products/inventory_management/list')),
  detail: lazy(() => import('views/products/detail/ProductsDetail')),
  reviews: lazy(() => import('views/products/review_details/ReviewList')),
  create: lazy(() => import('views/products/create/ProductsCreate')),
};
const orders = {
  list: lazy(() => import('views/orders/list/OrdersList')),
  return_list: lazy(() => import('views/orders/return_orders/returnList')),
  detail: lazy(() => import('views/orders/detail/OrdersDetail')),
  fraud_checker: lazy(() => import('views/pages/fraud_checker/FraudChecker')),
};

const roleManagement = {
  roles: lazy(() => import('views/role-management/RoleList')),
  roleForm: lazy(() => import('views/role-management/RoleForm')),
  adminUsers: lazy(() => import('views/role-management/AdminUsersList')),
};

const marketing = {
  email_campaign_create: lazy(() => import('views/marketing/email_campaign/MarketingEmailCampaignCreate')),
  email_campaign_list: lazy(() => import('views/marketing/email_campaign/EmailCampaignList')),
  email_campaign_detail: lazy(() => import('views/marketing/email_campaign/EmailCampaignDetail')),
  ad_campaign_create: lazy(() => import('views/marketing/ad_campaign/MarketingAdCampaignCreate')),
  add_discount: lazy(() => import('views/marketing/create_discount/MarketingCreateDiscount')),
  discount_list: lazy(() => import('views/marketing/discount_list/DiscountList')),
  discount_detail: lazy(() => import('views/marketing/discount_detail/DiscountDetail')),
};

const invertoryManagement = lazy(() => import('views/products/inventory_management/list'));


const analyticsReports = {
 stock_report: lazy(() => import('views/analytics_reports/stock_report/stockReport')),
 ip_block: lazy(() => import('views/analytics_reports/ip_block/ipBlock')),
 order_report: lazy(() => import('views/analytics_reports/order_report/orderReport')),
  
};

const gPixelGTM = {
  tag_manager: lazy(() => import('views/g_pixel_gtm/tag_manager/tagManager')),
  pixel_manager: lazy(() => import('views/g_pixel_gtm/pixel_manager/pixelManager')),
};

const apiIntegration = {
  api_setting: lazy(() => import('views/api_integration/api_setting/apiSetting')),
  transactions: lazy(() => import('views/api_integration/transactions/transactions')),
  payment_method: lazy(() => import('views/api_integration/payment_method/paymentMethod')),
  payment_system: lazy(() => import('views/api_integration/payment_method/payment_system/paymentSystem')),
  courier: lazy(() => import('views/api_integration/courier/courier')),
};


const bannerImages = {
  banner_category: lazy(() => import('views/banner_images/banner_category/bannerCategory')),
  banner_ads: lazy(() => import('views/banner_images/banner_ads/bannerAds')),
};

const pages = {
  best_sell: lazy(() => import('./views/pages/BestSell')),
  limited_edition: lazy(() => import('./views/pages/LimitedEdition')),
  products_pages: lazy(() => import('./views/pages/ProductsPages')),
};

const customers = {
  list: lazy(() => import('views/customers/list/CustomersList')),
  detail: lazy(() => import('views/customers/detail/CustomersDetail')),
  contact_us: lazy(() => import('views/customers/contact_us/ContactUsList')),
  newsletter_list: lazy(() => import('views/customers/new_product_alert/NewProductAlertList')),
};
const categories = {
  list: lazy(() => import('views/categories/list/CategoryList')),
  detail: lazy(() => import('views/categories/detail/CategoryDetail')),
  create: lazy(() => import('views/categories/create/CategoryCreate')),
};
const blogs = {
  list: lazy(() => import('views/blogs/list/BlogList')),
  detail: lazy(() => import('views/blogs/detail/BlogDetail')),
  create: lazy(() => import('views/blogs/create/BlogCreate')),
};
const headerFooter = {
  list: lazy(() => import('views/header_footer/list/headerFooterList')),
  detail: lazy(() => import('views/header_footer/detail/headerFooterDetail')),
  create: lazy(() => import('views/header_footer/create/headerFooterCreate')),
};
const shippingCharge = {
  list: lazy(() => import('views/shipping_charge/list/shippingChargeList')),
  detail: lazy(() => import('views/shipping_charge/detail/shippingChargeDetail')),
  create: lazy(() => import('views/shipping_charge/create/shippingChargeCreate')),
};

// const storefront = {
//   home: lazy(() => import('views/storefront/home/Home')),
//   filters: lazy(() => import('views/storefront/filters/Filters')),
//   categories: lazy(() => import('views/storefront/categories/Categories')),
//   detail: lazy(() => import('views/storefront/detail/Detail')),
//   cart: lazy(() => import('views/storefront/cart/Cart')),
//   checkout: lazy(() => import('views/storefront/checkout/Checkout')),
//   invoice: lazy(() => import('views/storefront/invoice/Invoice')),
// };
const shipping = lazy(() => import('views/shipping/Shipping'));
const settingsPage = lazy(() => import('views/settings/Settings'));
const storefrontSeoPage = lazy(() => import('views/storefront_seo/StorefrontSeo'));

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/dashboard`,
    },
    {
      path: `${appRoot}/dashboard`,
      component: dashboard,
      label: 'menu.dashboard',
      icon: 'dashboard',
      permission: 'dashboard',
    },
    // {
    //   path: `${appRoot}/storefront-landing-page`,
    //   component: storefrontLandingPage,
    //   label: 'menu.storefrontLanding',
    //   icon: 'content',
    // },
    // {
    //   path: `${appRoot}/header-footer`,
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/header-footer/list`,
    //   label: 'menu.hp',
    //   icon: 'input',
    //   subs: [
    //     { path: '/list', label: 'menu.list', component: headerFooter.list },
    //     { path: '/detail/:type', label: 'menu.list', component: headerFooter.detail, show: false },
    //     { path: '/create', label: 'menu.create', component: headerFooter.create },
    //   ],
    // },
    // {
    //   path: `${appRoot}/shipping-charge`,
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/shipping-charge/list`,
    //   label: 'menu.sc',
    //   icon: 'plane',
    //   subs: [
    //     { path: '/list', label: 'menu.list', component: shippingCharge.list },
    //     { path: '/detail/:id', label: 'menu.list', component: shippingCharge.detail, show: false },
    //     { path: '/create', label: 'menu.create', component: shippingCharge.create },
    //   ],
    // },
    {
      path: `${appRoot}/customers`,
      exact: true,
      redirect: true,
      to: `${appRoot}/customers/list`,
      label: 'menu.customers',
      icon: 'user',
      subs: [
        { path: '/list', label: 'menu.customers_list', component: customers.list, permission: 'consumers.customers_list.view' },
        { path: '/detail/:customerId', label: 'menu.detail', component: customers.detail, show: false, permission: 'consumers.customers_list.detail.read' },
        { path: '/contact-us', label: 'menu.contact_us', component: customers.contact_us, permission: 'consumers.contact_us.view' },
        { path: '/new-product-alert', label: 'menu.newsletter_list', component: customers.newsletter_list, permission: 'consumers.newsletter_list.view' },
      ],
    },
    {
      path: `${appRoot}/categories`,
      exact: true,
      redirect: true,
      to: `${appRoot}/categories/category-list`,
      label: 'menu.category',
      icon: 'layout-5',
      subs: [
        { path: '/list', label: 'menu.list', component: categories.list, permission: 'categories.list.view' },
        { path: '/detail/:categoryId', label: 'menu.list', component: categories.detail, show: false, permission: 'categories.list.detail.read' },
        { path: '/create', label: 'menu.create', component: categories.create, permission: 'categories.list.create' },
      ],
    },
    {
      path: `${appRoot}/pages`,
      exact: true,
      redirect: true,
      to: `${appRoot}/pages/best-sell`,
      label: 'menu.pages',
      icon: 'content',
      subs: [
        { path: '/best-sell', label: 'menu.best_sell', component: pages.best_sell, permission: 'pages.best_sell.view' },
        { path: '/limited-edition', label: 'menu.limited_edition', component: pages.limited_edition, permission: 'pages.limited_edition.view' },
        { path: '/products-pages', label: 'menu.products_pages', component: pages.products_pages, permission: 'pages.products_pages.view' },
      ],
    },
    {
      path: `${appRoot}/products`,
      exact: true,
      redirect: true,
      to: `${appRoot}/products/list`,
      label: 'menu.products',
      icon: 'product',
      subs: [
        { path: '/list', label: 'menu.list', component: products.list, permission: 'products.list.view' },
        { path: '/create', label: 'menu.create', component: products.create, permission: 'products.list.create' },
        { path: '/invertory_management', component: invertoryManagement, label: 'menu.inventory_management', permission: 'products.inventory.view' },
        { path: '/detail/:productId', label: 'menu.detail', component: products.detail, show: false, permission: 'products.list.detail.read' },
        { path: '/review_details/:productId', label: 'menu.reviews', component: products.reviews, show: false, permission: 'products.reviews.view' },
      ],
    },
    {
      path: `${appRoot}/blog`,
      exact: true,
      redirect: true,
      to: `${appRoot}/blogs/blog-list`,
      label: 'menu.blogs',
      icon: 'blog',
      subs: [
        { path: '/list', label: 'menu.list', component: blogs.list, permission: 'blogs.list.view' },
        { path: '/detail/:blogId', label: 'menu.list', component: blogs.detail, show: false, permission: 'blogs.list.detail.read' },
        { path: '/create', label: 'menu.create', component: blogs.create, permission: 'blogs.list.create' },
      ],
    },
    {
      path: `${appRoot}/orders`,
      exact: true,
      redirect: true,
      to: `${appRoot}/orders/list`,
      label: 'menu.orders',
      icon: 'order',
      subs: [
        { path: '/list', label: 'menu.list', component: orders.list, permission: 'orders.list.view' },
        { path: '/returnList', label: 'menu.return_list', component: orders.return_list, permission: 'orders.return_list.view' },
        { path: '/fraud-checker', label: 'menu.fraud_checker', component: orders.fraud_checker, permission: 'consumers.fraud_checker.view' },
        { path: '/detail/:orderId', label: 'menu.detail', component: orders.detail, show: false, permission: 'orders.list.detail.read' },
      ],
    },
    {
      path: `${appRoot}/role-management`,
      exact: true,
      redirect: true,
      to: `${appRoot}/role-management/roles`,
      label: 'menu.role_management',
      icon: 'user',
      subs: [
        { path: '/roles/create', exact: true, label: 'menu.role_management_create', component: roleManagement.roleForm, show: false, permission: 'role_management.roles.create' },
        { path: '/roles/edit/:roleId', exact: true, label: 'menu.role_management_edit', component: roleManagement.roleForm, show: false, permission: 'role_management.roles.edit' },
        { path: '/roles', exact: true, label: 'menu.role_management_roles', component: roleManagement.roles, permission: 'role_management.roles.view' },
        { path: '/admin-users', label: 'menu.role_management_admin_users', component: roleManagement.adminUsers, permission: 'role_management.admin_users.view' },
      ],
    },
    {
      path: `${appRoot}/marketing`,
      exact: true,
      redirect: true,
      to: `${appRoot}/marketing/discount-list`,
      label: 'menu.marketing',
      icon: 'marketing',
      subs: [
        { path: '/discount-list', label: 'menu.discount_list', component: marketing.discount_list, permission: 'marketing.discount_list.view' },
        { path: '/add-discount', label: 'menu.add_discount', component: marketing.add_discount, show: false, permission: 'marketing.discount_list.create' },
        { path: '/discount-detail/:couponId', label: 'menu.discount_detail', component: marketing.discount_detail, show: false, permission: 'marketing.discount_list.detail' },
        { path: '/email-campaign-list', label: 'menu.email_campaign_list', component: marketing.email_campaign_list, permission: 'marketing.email_campaigns.view' },
        { path: '/email-campaign-detail/:campaignId', label: 'menu.email_campaign_detail', component: marketing.email_campaign_detail, show: false, permission: 'marketing.email_campaigns.view' },
        { path: '/email-campaign-create', label: 'menu.email_campaign_create', component: marketing.email_campaign_create, show: false, permission: 'marketing.email_campaigns.create' },
        { path: '/ad-campaign-create', label: 'menu.ad_campaign', component: marketing.ad_campaign_create, permission: 'marketing.ad_campaign.view' },
      ],
    },
    //     {
    //   path: `${appRoot}/analytics_reports`,
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/analytics_reports/stock_reports`,
    //   label: 'menu.analytics_reports',
    //   icon: 'analytics',
    //   subs: [
    //     { path: '/stock_report', label: 'menu.stock_report', component:  analyticsReports.stock_report},
    //       { path: '/ip_block', label: 'menu.ip_block', component:  analyticsReports.ip_block},
    //    { path: '/order_report', label: 'menu.order_report', component:  analyticsReports.order_report},
    //   ],
    // },

    
   
  // {
  //     path: `${appRoot}/shipping`,
  //     component: shipping,
  //     label: 'menu.shipping',
  //     icon: 'shipping',
  //   },
    {
      path: `${appRoot}/shipping`,
      exact: true,
      redirect: true,
      to: `${appRoot}/shipping/courier`,
      label: 'menu.shipping_delivery',
      icon: 'shipping',
      subs: [
        { path: '/courier', label: 'menu.courier', component: apiIntegration.courier, permission: 'shipping.courier.view' },
      ],
    },
    {
      path: `${appRoot}/api_integration`,
      exact: true,
      redirect: true,
      to: `${appRoot}/api_integration/api_setting`,
      label: 'menu.api_integration',
      icon: 'api',
      subs: [
        { path: '/api_setting', label: 'menu.api_setting', component: apiIntegration.api_setting, show: false, permission: 'api_integration.api_setting.view' },
        { path: '/payment_method', label: 'menu.payment_method', component: apiIntegration.payment_method, permission: 'api_integration.payment_method.view' },
      ],
    },


    {
      path: `${appRoot}/g_pixel_gtm`,
      exact: true,
      redirect: true,
      to: `${appRoot}/g_pixel_gtm/tag_manager`,
      label: 'menu.g_pixel_gtm',
      icon: 'gtm',
      subs: [
        { path: '/tag_manager', label: 'menu.tag_manager', component: gPixelGTM.tag_manager, permission: 'g_pixel_gtm.tag_manager.view' },
        { path: '/pixel_manager', label: 'menu.pixel_manager', component: gPixelGTM.pixel_manager, permission: 'g_pixel_gtm.pixel_manager.view' },
      ],
    },

    {
      path: `${appRoot}/storefront-seo`,
      component: storefrontSeoPage,
      label: 'menu.storefront_seo',
      icon: 'search',
      permission: 'settings.general.view',
    },
    {
      path: `${appRoot}/settings`,
      component: settingsPage,
      label: 'menu.settings',
      icon: 'gear',
      permission: 'settings.general.view',
    },

    // {
    //   path: `${appRoot}/banner_images`,
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/banner_images/banner_category`,
    //   label: 'menu.banner_images',
    //   icon: 'banner',
    //   subs: [
    //     { path: '/banner_category', label: 'menu.banner_category', component: bannerImages.banner_category },
    //     { path: '/banner_ads', label: 'menu.banner_ads', component: bannerImages.banner_ads },
    //   ],
    // },

  
    // {
    //   path: `${appRoot}/storefront`,
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/storefront/home`,
    //   label: 'menu.storefront',
    //   icon: 'screen',
    //   subs: [
    //     { path: '/home', label: 'menu.home', component: storefront.home },
    //     { path: '/filters', label: 'menu.filters', component: storefront.filters },
    //     { path: '/categories', label: 'menu.categories', component: storefront.categories },
    //     { path: '/detail', label: 'menu.detail', component: storefront.detail },
    //     { path: '/cart', label: 'menu.cart', component: storefront.cart },
    //     { path: '/checkout', label: 'menu.checkout', component: storefront.checkout },
    //     { path: '/invoice', label: 'menu.invoice', component: storefront.invoice },
    //   ],
    // },
  
    // {
    //   path: `${appRoot}/discount`,
    //   component: discount,
    //   label: 'menu.discount',
    //   icon: 'tag',
    // },
    // {
    //   path: `${appRoot}/settings`,
    //   component: settings.home,
    //   label: 'menu.settings',
    //   icon: 'gear',
    //   subs: [{ path: '/general', component: settings.general, hideInMenu: true }],
    // },
  ],
  sidebarItems: [],
};
export default routesAndMenuItems;
